import template from './privacyDeclaration.html';
import controller from './privacyDeclaration.controller';
import './privacyDeclaration.scss';

let privacyDeclarationComponent = {
  bindings: {
    lang: '@'
  },
  template,
  controller
};

export default privacyDeclarationComponent;



// WEBPACK FOOTER //
// ./client/app/common/privacyDeclaration/privacyDeclaration.component.js